var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/LoadMoreContent/LoadMoreContent.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { Button } from '@mui/material';
import { getGroupPendingKey } from "../../../ClassifierTree/model/pendingModel";
import { buildKeyByPath } from "../../../ClassifierTree/utils";
import { getStyle } from "../../../Common/getStyle";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadMoreContent = function LoadMoreContent(_ref) {
  var node = _ref.node,
      path = _ref.path,
      onLoadMore = _ref.onLoadMore,
      inSearch = _ref.inSearch,
      onPending = _ref.onPending;
  var parentNode = node.parentNode;

  var _ref2 = 'children' in parentNode ? parentNode : {
    total: 0,
    children: []
  },
      total = _ref2.total,
      children = _ref2.children;

  var left = total - children.length;
  var more = left > 40 ? 40 : left;
  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;
  var highlightedInSearch = false;

  if (matched) {
    highlightedInSearch = true;

    if (fullMatch) {
      highlightedInSearch = true;
    }
  }

  var style = getStyle({
    highlightedInSearch: highlightedInSearch
  });
  var parentPath = path.slice(0, -1);
  return /*#__PURE__*/_jsx("div", {
    style: {
      marginLeft: "".concat((path.length - 1) * 18, "px"),
      paddingLeft: '80px'
    },
    children: /*#__PURE__*/_jsxs(Button, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        whiteSpace: 'nowrap'
      }),
      disabled: onPending(getLoadMorePendingKey(node.parentNode, parentPath)),
      variant: "contained",
      size: "small",
      onClick: function onClick() {
        return onLoadMore(parentNode, children.length, buildKeyByPath(parentPath));
      },
      children: ["\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0435\u0449\u0451 ", more, " \u0438\u0437 ", left]
    })
  });
};

function getLoadMorePendingKey(node, path) {
  if (node.type === 'UserClassifierGroupNode') {
    return getGroupPendingKey(node);
  }

  return buildKeyByPath(path);
}